import { useState } from "react";
import { Loader2, Lock } from "lucide-react";

export function IQAdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await onLogin(email, password);
    } catch (err) {
      setError(err?.response?.data?.detail || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6" data-testid="iq-admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-zinc-800 rounded-2xl p-8 bg-[#111]">
        <div className="w-11 h-11 rounded-xl bg-[#ff2d78]/10 flex items-center justify-center text-[#ff2d78] mb-6">
          <Lock size={18} strokeWidth={1.75} />
        </div>
        <h1 className="font-heading text-xl font-medium">WearSpray IQ — Admin</h1>
        <p className="font-body text-sm text-zinc-500 mt-2">Sign in to view registrations.</p>

        <div className="space-y-3 mt-6">
          <input
            data-testid="iq-admin-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full bg-[#1a1a1a] border border-zinc-700 rounded-lg px-4 py-3 text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-[#ff2d78] transition-colors"
          />
          <input
            data-testid="iq-admin-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-[#1a1a1a] border border-zinc-700 rounded-lg px-4 py-3 text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-[#ff2d78] transition-colors"
          />
        </div>

        {error && <p data-testid="iq-admin-login-error" className="font-body text-sm text-red-400 mt-4">{error}</p>}

        <button
          type="submit"
          data-testid="iq-admin-login-submit"
          disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2 font-body text-sm font-medium bg-[#ff2d78] text-white px-6 py-3.5 rounded-lg mt-6 hover:bg-white hover:text-black transition-colors disabled:opacity-60"
        >
          {loading ? <><Loader2 size={15} className="animate-spin" /> Signing in…</> : "Sign In"}
        </button>
      </form>
    </div>
  );
}
